import { routerSwitch, Updater } from "widgets-for-react";
import { Routes } from "../../../Shared/Frontend/utils/routes.shared";
import { application } from "../allIncludedModules";
import { updatePageViewBasedOnState } from "../cms/utils/pageViews";
import { State } from "../root/root.state";
import { Pages } from "./routes.state";

export const routeWidgets: Routes<State, Pages> =
{
  ...application.routeWidgetsObject<State, Pages>(),
}

export const routes = () =>
  routerSwitch<Updater<State>>()([
    ...application.routeWidgets<State, Pages>()
  ])
  .map<Updater<State>>(u => os => updatePageViewBasedOnState(u, os))
